import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { mapGetters } from "vuex";

import { TminMaxValue } from "@/components/ChartDataLayout/types";
import UserFull from "@/vuex/models/user/user-full";

@Component({
  name: "ChartLine",
  components: {
    LineChartGenerator,
  },
  computed: mapGetters({
    me: "me",
  }),
})
export default class ChartLine extends Vue {
  @Prop({
    type: Number,
    required: false,
    default: 400,
  })
  public width!: number;

  @Prop({
    type: Number,
    required: false,
    default: 350,
  })
  public height!: number;

  @Prop({
    type: Object,
    required: false,
  })
  public chartData!: any;

  @Prop({
    type: Number,
    required: false,
  })
  public isDuration!: number;

  @Prop({
    type: Object,
    required: false,
  })
  public minMaxValue!: TminMaxValue;

  public chartOptions = {};
  protected readonly me!: UserFull;

  @Watch("isDuration", { immediate: true })
  @Watch("minMaxValue", { immediate: true, deep: true })
  updateOptions() {
    let isThemeDark =
      this.me.theme === "theme-dark" ||
      (this.me.theme === "theme-default" &&
        window.matchMedia("(prefers-color-scheme: dark)").matches);

    let trickColor = isThemeDark ? "#CCCCCC" : "#6D6D6D";
    let gridColor = isThemeDark ? "#585858" : "#DEDEDE";

    const baseChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        point: {
          hoverRadius: 10,
        },
        line: {
          tension: 0.4,
        },
      },
      plugins: {
        tooltip: {
          displayColors: false,
          backgroundColor: "white",
          bodyColor: "#1DE591",
          borderWidth: 1,
          padding: {
            top: 8,
            left: 22.2,
            right: 22.2,
            bottom: 8,
          },
          borderColor: "#DEDEDE",
          titleFont: {
            size: 0,
          },
          bodyFont: {
            size: 14,
            color: "black",
          },
        },
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          color: trickColor,
        },
        y: {
          ticks: {
            callback: (value: number) => {
              return +value.toFixed(0);
            },
            maxTicksLimit: 4,
            color: trickColor,
          },
          grid: {
            color: gridColor,
            drawBorder: false,
          },
        },
      },
    };

    if (this.minMaxValue) {
      this.chartOptions = {
        ...baseChartOptions,
        scales: {
          x: {
            grid: {
              display: false,
            },
            ticks: {
              color: trickColor,
            },
          },
          y: {
            ticks: {
              callback: (value: number) => {
                return this.isDuration === 2
                  ? value.toFixed(1) + " m"
                  : value.toFixed(0);
              },
              color: trickColor,
              maxTicksLimit: 4,
            },
            grid: {
              color: gridColor,
              drawBorder: false,
            },
            ...this.minMaxValue,
          },
        },
      };
    } else {
      this.chartOptions = {
        ...baseChartOptions,
        scales: {
          x: {
            grid: {
              display: false,
            },
            ticks: {
              color: trickColor,
            },
          },
          y: {
            ticks: {
              maxTicksLimit: 4,
              callback: (value: number) => {
                return this.isDuration === 2
                  ? value.toFixed(1) + " m"
                  : value.toFixed(0);
              },
              color: trickColor,
            },
            grid: {
              color: gridColor,
              drawBorder: false,
            },
          },
        },
      };
    }
  }
}
